import { cn } from "@/lib/utils";

/**
 * The official Studio Park / Staff Hub combined wordmark — pink "Studio
 * Park" wordmark on the left, a vertical divider, and "STAFF HUB"
 * letter-spaced label on the right. One image, two color variants:
 *
 *   • lockup-on-dark.png   — cream "STAFF HUB" text, for dark surfaces
 *   • lockup-on-light.png  — slate "STAFF HUB" text, for light surfaces
 *
 * We render both and swap visibility via Tailwind `dark:` so a theme
 * toggle re-skins the lockup instantly without a re-render. Source
 * dimensions are 1044x244 (~4.28:1); set the height via the `className`
 * prop and width auto-scales.
 *
 * Use this everywhere the app communicates "Studio Park Staff Hub" as a
 * destination — landing nav, auth screens, AppShell, AdminShell. For
 * places that just need the pink Studio Park wordmark alone (no Staff
 * Hub suffix), keep using /studio-park-logo.png directly.
 */
export function StaffHubLockup({
  className,
  alt = "Studio Park Staff Hub",
}: {
  /** Tailwind classes — typically a height like `h-10 w-auto`. */
  className?: string;
  /** Accessible label. Default reads naturally for screen readers. */
  alt?: string;
}) {
  return (
    <>
      <img
        src="/lockup-on-light.png"
        alt={alt}
        className={cn("block dark:hidden", className)}
      />
      <img
        src="/lockup-on-dark.png"
        alt=""
        aria-hidden="true"
        className={cn("hidden dark:block", className)}
      />
    </>
  );
}
